// Justified Gallery
import 'justifiedGallery/dist/js/jquery.justifiedGallery';


$('#imgJustify, #designJustify').justifiedGallery({
  rowHeight: 300,
  lastRow: 'justify',
  margins: 20,
  sizeRangeSuffixes: {},
});

// Hinh anh khach hang
$("#imgJustify > a").on("click", function () {
  var $info = $(this).find('.content-information-customer');
  $('#imagepreview').attr('src', $info.find('>img').attr('src'));
  $(".gellary-information-customer").html(
    "<h5>" + $info.find('>h5').text() + "</h5>" +
    "<span>" + $info.find('>span').text() + "</span>" +
    "<p>" + $info.find('>p').text() + "</p>"
  );

  $('#imagemodal').modal('show');
  return false;
});


//San pham goi y thiet ke
$("#designJustify > a").on("click", function () {
  var $info = $(this).find('.content-information-customer');
  $('#imagepreview').attr('src', $info.find('>img').attr('src'));
  $(".gellary-information-customer").html(
    "<h5>" + $info.find('>h5').text() + "</h5>" +
    "<span>" + $info.find('>span').text() + "</span>" +
    "<p>" + $info.find('>p').text() + "</p>"
  );

  $('#imagemodal').modal('show');
  return false;
});



$("#inputJustify").on("click", function () {
  $('#inputGallery').modal('show');
  return false;
});


//  Thiet ke goi y
// $("#mygallery > a").on("click", function () {
//   var nameCustomer = $(this).find(".content-information-customer > h5").text();
//   var feedback = $(this).find(".content-information-customer > p").text();
//   $(".design-information").html("<h3 class='name'>" + nameCustomer + "</h3> <div class='desc'>" + feedback + "</div>");
//   $('#designPreview').attr('src', $(this).find('img').attr('src'));

//   $('#designModal').modal('show');
//   return false;
// });
$('#imagemodal').on('shown.bs.modal', function (e) {
  $('#mygallery').justifiedGallery({
    rowHeight: 250,
    lastRow: 'justify',
    margins: 5,
    sizeRangeSuffixes: {},
  });
});


// Desktop menu
function MenuSpace () {
  var extras = true;

  if ($(window).width() > 991) {
    var $dskmenu = $('.menu-desktop');
    if ($('#slideshow').length > 0) {
      extras = false;
      if ($(window).scrollTop() > 0) $dskmenu.addClass('scroll-menu');
      else $dskmenu.removeClass('scroll-menu');
    }
    else {
      $dskmenu.addClass('scroll-menu');
    }
  }

  if (extras) {
    var $newmnu = $('.menu-new'),
      $space = $('.menu-space');
    if ($space.length == 0) {
      $space = $('<div class="menu-space"/>').insertAfter($newmnu);
    }
    $space.height($newmnu.find('>*:visible').outerHeight());
  }
}

MenuSpace();
$(window).on('load scroll', MenuSpace);


// Mobile menu
$('#icon-sidebar').click(function (e) {
  e.stopPropagation();
  $(this).hide();
  $("#icon-stop").show();
  $(".navbar-right-down").addClass("show-mobile");
  $('.lean-overlay').addClass("lean-overlay-sh");
});

$('.lean-overlay,#icon-stop').click(function (e) {
  e.stopPropagation();
  $("#icon-sidebar").show();
  $("#icon-stop").hide();
  $(".navbar-right-down,.level_2").removeClass("show-mobile");
  $('.lean-overlay').removeClass("lean-overlay-sh");
});

$('.three-menu > a').on("click", function (e) {
  e.preventDefault();
  $(this).next().addClass("show-mobile");
});

$('.pre_menu_level2 > a').click(function (e) {
  e.preventDefault();
  $(this).parent().parent().removeClass("show-mobile");
});

$(".regular").slick({
  // dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '50px'
      }
    }
  ]
});

$(".center").slick({
  // dots: true,
  infinite: true,
  // centerMode: true,
  slidesToShow: 5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '50px'
      }
    }
  ]
});
$(".variable").slick({
  dots: true,
  infinite: true,
  variableWidth: true
});



// WEBPACK FOOTER //
// ./src/themNew.js